import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { helmetJsonLdProp } from 'react-schemaorg';

import { reviewContentItemMapper } from '../BazzarvoiceReviews/utils';

const SchemaMarkup = ({ reviewContentItems, productName, averageRating, totalReviews, productUrl }) => {
  if (!reviewContentItems || reviewContentItems.length === 0) {
    return null;
  }

  const reviews = reviewContentItems.map(reviewContentItem => {
    const item = reviewContentItemMapper(reviewContentItem);
    return {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: item.posterNickname,
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: item.ratings,
        bestRating: 5,
        worstRating: 1,
      },
    };
  });

  const productSchema = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: productName || 'Owens Corning Shingles',
    url: productUrl,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: averageRating || 0,
      reviewCount: totalReviews || reviewContentItems.length,
      bestRating: 5,
      worstRating: 1,
    },
    review: reviews,
  };

  return <Helmet script={[helmetJsonLdProp(productSchema)]} />;
};

SchemaMarkup.propTypes = {
  reviewContentItems: PropTypes.arrayOf(
    PropTypes.shape({
      posterNickname: PropTypes.string,
      productName: PropTypes.string,
      ratings: PropTypes.number,
    })
  ).isRequired,
  productName: PropTypes.string,
  averageRating: PropTypes.number,
  totalReviews: PropTypes.number,
  productUrl: PropTypes.string,
};

SchemaMarkup.defaultProps = {
  productName: 'Owens Corning Shingles',
  averageRating: 0,
  totalReviews: 0,
  productUrl: undefined,
};

export { SchemaMarkup };
